import { Link, LinkProps } from "@mui/material";
import { IconArrowRight } from "src/components/icons-mui/arrow-right";
import { toSxArray } from "src/utils/mui/sx/sx";

export type IArrowLinkProps = LinkProps;

export const ArrowLink = ({ children, sx, ...linksProps }: IArrowLinkProps) => {
    const hoverColor = linksProps.color === "green" ? "green.600" : "gray.800";

    return (
        <Link
            underline="hover"
            sx={[
                {
                    "&:hover": {
                        color: hoverColor,
                        "&.MuiLink-underlineAlways": {
                            textDecorationColor: hoverColor,
                        },
                    },
                },
                ...toSxArray(sx),
            ]}
            {...linksProps}
        >
            <>
                {children}
                <IconArrowRight sx={{ marginLeft: 0.5 }} />
            </>
        </Link>
    );
};
